import { makeVar } from "@apollo/client";

// On load, initialize the selectedFrame from localStorage
export const selectedFrameIdVar = makeVar(localStorage.getItem("selectedFrameId"));

